import { Component, Input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import {
  invalidDecimalSeperatorForLocaleRegex,
  Locale,
  stringNumberConverterForLocale,
  ValidationClassesDirective,
  HasValueDirective,
} from '@innogy/utils-deprecated';
import type { FormState } from 'ngrx-forms';
import {
  NGRX_UPDATE_ON_TYPE,
  NgrxValueConverter,
  NgrxFormsModule,
} from 'ngrx-forms';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TrackFieldfocusDirective } from '@analytics/events';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';

@Component({
  selector: 'wl-number',
  templateUrl: './number.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    AutomationIdDirective,
    NgrxFormsModule,
    AutomationIdDirective,
    ValidationClassesDirective,
    HasValueDirective,
    TrackFieldfocusDirective,
    CommonUiUtilityComponentsModule,
  ],
})
export class NumberComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formsControl?:
    | FormState<string | undefined>
    | FormState<number | undefined>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() overrideNgrxValueConverter?: NgrxValueConverter<
    string,
    number | undefined
  >;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() placeholder = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() label = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() tooltip = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() inputClass?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() toolName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() stepName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fieldName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() hashValue?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() sendValue? = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() step?: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() floatingLabel = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() updateOn: `${NGRX_UPDATE_ON_TYPE}` = NGRX_UPDATE_ON_TYPE.CHANGE;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() skipDirtyCheck = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() allowDotsAndCommas? = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() autoFocus? = false;
  /**
   * FIXME: should be 'nl-NL' for all usages of <wl-number>. After changing this it
   *        should be thoroughly tested by all teams. If this "NL" locale is not
   *        sufficient for one of the use-cases, the en-US locale can be used.
   */
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() locale: Locale = 'en-US';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() inputmode = 'numeric';

  get ngrxValueConverter(): NgrxValueConverter<string, number | undefined> {
    return (
      this.overrideNgrxValueConverter ||
      stringNumberConverterForLocale(this.locale)
    );
  }

  onKeyDown(event: KeyboardEvent) {
    /**
     * Prevent certain keys from being typed instead of letting the ngrxValueConverter clear the
     * entire input when an invalid character is typed.
     */
    if (this.allowDotsAndCommas) {
      return;
    }

    return !invalidDecimalSeperatorForLocaleRegex(this.locale).test(event.key);
  }
}
